import React, { forwardRef } from 'react'
import styled from 'styled-components'
import { navigate } from 'gatsby'
import { MEDIUM, DESKTOP } from '@streamr/streamr-layout/styled'
import core from './assets/core.png'
import core2x from './assets/core@2x.png'
import dataunions from './assets/dataunions.png'
import dataunions2x from './assets/dataunions@2x.png'
import marketplace from './assets/marketplace.png'
import marketplace2x from './assets/marketplace@2x.png'
import networkExplorer from './assets/network-explorer.png'
import networkExplorer2x from './assets/network-explorer@2x.png'

const assets = {
    dataunions: [dataunions, dataunions2x],
    marketplace: [marketplace, marketplace2x],
    core: [core, core2x],
    networkexplorer: [networkExplorer, networkExplorer2x],
}

const UnstyledIcon = ({ name, ...props }) => {
    if (!assets[name]) {
        return null
    }

    const [icon, icon2x] = assets[name]

    return (
        <div {...props}>
            <img src={icon} srcSet={icon2x} alt="" />
        </div>
    )
}

const Icon = styled(UnstyledIcon)`
    border-top-left-radius: 8px;
    border-top-right-radius: 8px;
    background-color: #F5F5F5;
    height: 208px;
    position: relative;

    img {
        width: 130px;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
    }

    @media (min-width: ${DESKTOP}px) {
        img {
            width: 110px;
        }
    }
`

const Content = styled.div`
    background-color: #FFFFFF;
    border-bottom-left-radius: 8px;
    border-bottom-right-radius: 8px;
    padding: 1.25rem 2.25rem 2rem 1.875rem;
    font-size: 0.875rem;
    line-height: 1.5rem;
    color: #0C009A;

    p {
        margin: 0;
    }

    p + p {
        margin-top: 1.25rem;
    }
`

const Title = styled.h3`
    font-size: 1.25rem;
    line-height: 1.5rem;
    font-weight: ${MEDIUM};
    margin: 0;
    margin-bottom: 1.25rem;
`

const UnstyledAppCard = forwardRef(({
    icon,
    title,
    children,
    to,
    ...props
}, ref) => (
    <button
        {...props}
        type="button"
        onClick={() => navigate(to)}
        ref={ref}
    >
        <Icon name={icon} />
        <Content>
            <Title>{title}</Title>
            {children}
        </Content>
    </button>
))

const AppCard = styled(UnstyledAppCard)`
    display: flex;
    flex-direction: column;
    display: block;
    text-align: left;
    appearance: none;
    background: transparent;
    margin: 0;
    padding: 0;
    border: 0;
    cursor: pointer;
    align-items: stretch;

    ${Content} {
        flex: 1;
    }
`

export default AppCard
